import PropTypes from 'prop-types';
import { FormGroup, Label, TextField } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

import styles from './EmailField.module.scss';

const EmailField = ({ value, onChange, disabled }) => (
  <div className={styles.emailField}>
    <FormGroup>
      <Label size="sm" for={credentialForm.emailId}>
        {credentialForm.emailLabel}
      </Label>
      <TextField
        id={credentialForm.emailId}
        size="sm"
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </FormGroup>
  </div>
);

EmailField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

EmailField.defaultProps = {
  value: '',
  onChange: noop,
  disabled: false,
};

export default EmailField;
